const INITIAL_STATE = {
  status: "PENDING",
  list: {}
}

export default INITIAL_STATE
